var render = function () {
  var _vm$blob$btn, _vm$blob$text;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "resize-box absolute-fill",
    class: {
      'as-override': !_vm.isPrimary
    }
  }), _vm.canTransform ? [_vm._l([[-1, -1], [1, -1], [1, 1], [-1, 1]], function (_ref) {
    var x = _ref[0],
        y = _ref[1];
    return _vm.blob.type != 'BTN' ? _c('div', {
      key: ("" + x + y),
      staticClass: "corner-btn",
      style: {
        left: x < 0 ? -_vm.btnOffset + 'px' : undefined,
        right: x > 0 ? -_vm.btnOffset + 'px' : undefined,
        top: y < 0 ? -_vm.btnOffset + 'px' : undefined,
        bottom: y > 0 ? -_vm.btnOffset + 'px' : undefined
      },
      on: {
        "mousedown": function (e) {
          return _vm.$emit('resize', e);
        },
        "touchstart": function (e) {
          return _vm.$emit('resize', e);
        }
      }
    }, [_c('v-btn', {
      directives: [{
        name: "blur",
        rawName: "v-blur"
      }],
      staticClass: "ma-3",
      attrs: {
        "fab": "",
        "x-small": "",
        "absolute": "",
        "color": "red",
        "disabled": _vm.isShowingVirtualKeyboard
      }
    })], 1) : _vm._e();
  }), _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "calc(50% - 52px)",
      "bottom": "-120px",
      "padding": "24px",
      "pointer-events": "auto"
    },
    on: {
      "mousedown": function (e) {
        return _vm.$emit('rotate', e);
      },
      "touchstart": function (e) {
        return _vm.$emit('rotate', e);
      }
    }
  }, [_c('tooltip-btn', {
    attrs: {
      "msg": "Drag to rotate",
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var on = _ref2.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          attrs: {
            "fab": "",
            "color": "red",
            "disabled": _vm.isShowingVirtualKeyboard
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "white"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiRotateRight)
          }
        })], 1)];
      }
    }], null, false, 4241393573)
  })], 1), !((_vm$blob$btn = _vm.blob.btn) !== null && _vm$blob$btn !== void 0 && _vm$blob$btn.form) && !(_vm.mode == 'edit' && ['GIFTCARD', 'GROUP_VIDEO'].includes(_vm.blob.type)) ? _c('tooltip-btn', {
    attrs: {
      "msg": "Delete",
      "bottom": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var on = _ref3.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          staticStyle: {
            "left": "calc(50% - 28px)",
            "top": "-96px",
            "pointer-events": "auto"
          },
          attrs: {
            "fab": "",
            "absolute": "",
            "color": "red"
          },
          on: {
            "click": function ($event) {
              $event.stopPropagation();
              return _vm.$emit('delete');
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "white"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.mdiDelete)
          }
        })], 1)];
      }
    }], null, false, 619876644)
  }) : _vm._e()] : (_vm$blob$text = _vm.blob.text) !== null && _vm$blob$text !== void 0 && _vm$blob$text.event_link && _vm.mode != 'design' ? _c('div', {
    staticStyle: {
      "position": "absolute",
      "left": "calc(50% - 28px)",
      "bottom": "-72px",
      "pointer-events": "auto"
    }
  }, [_c('tooltip-btn', {
    attrs: {
      "top": "",
      "msg": _vm.blob.text.event_link.disabled ? 'Automatically set text from event details' : 'Edit text directly'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var on = _ref4.on;
        return [_c('v-btn', _vm._g({
          directives: [{
            name: "blur",
            rawName: "v-blur"
          }],
          attrs: {
            "fab": "",
            "color": "red",
            "disabled": _vm.isShowingVirtualKeyboard
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('update-text-event-link-disabled', !_vm.blob.text.event_link.disabled);
            }
          }
        }, on), [_c('v-icon', {
          attrs: {
            "color": "white"
          },
          domProps: {
            "innerHTML": _vm._s(_vm.blob.text.event_link.disabled ? _vm.mdiCalendarEdit : _vm.mdiPencil)
          }
        })], 1)];
      }
    }])
  })], 1) : _vm._e()], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }